<div class="filepond--wrapper">
   <input type="file"/>
 </div>
